module.exports = __webpack_public_path__ + "ath_game_web/img/4.5.0d069286.png";